import { Menu } from "antd";
import { ItemType } from "antd/es/menu/hooks/useItems";
import React, { FC } from "react";

interface SidebarMenuProps {
  handleActiveLink: (e: { key: React.Key }) => void;
  pathname: string;
  translatedSidebarItems: ItemType[];
  selectMenuKeys: () => string[];
}

const SidebarMenu: FC<SidebarMenuProps> = ({
  handleActiveLink,
  pathname,
  translatedSidebarItems,
  selectMenuKeys,
}) => {
  const themeColor = JSON.parse(
    localStorage.getItem("color-theme") || '"#002F5F"'
  );

  return (
    <div className="h-full overflow-auto sidebar w-full">
      <Menu
        mode="inline"
        onClick={handleActiveLink}
        selectedKeys={[pathname]}
        className="text-[12px]"
        style={{
          backgroundColor: themeColor,
        }}
        items={translatedSidebarItems as ItemType[]}
        defaultSelectedKeys={selectMenuKeys()}
        defaultOpenKeys={selectMenuKeys()}
      />
    </div>
  );
};

export { SidebarMenu };
